import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight, faSearch, faEye, faEyeSlash, faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'react-tooltip';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ElementStatus.css';
import '../../Shared/Searchbar.css'; // Import your CSS file
import GoCast from '../../Images/GoCast.png'
import { useNavigate } from "react-router-dom";

function ElementStatus_Dashboard() {
  // Loading GIF
  const [isLoading, setIsLoading] = useState(false);
  // Search-bar
  const [searchOpen, setSearchOpen] = useState(false);
  // Table visibility
  const [tableVisible, setTableVisible] = useState(true);
  // API CODE
  const [apiData, setApiData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Adjust this number as needed

  // Navigation To Another Page
  const navigate = useNavigate();


  // Filter Second Grid By Taking The Project ID & Filter in Second API 
  const [selectedProjectID, setSelectedProjectID] = useState(null);
  const [selectedUOM, setSelectedUOM] = useState(null);
  console.log(selectedProjectID);
  console.log(selectedUOM);


  const fetchData = async () => {
    setIsLoading(true); // Load GIF
    const username = 'manager'; // Replace with your username
    const password = 'manager'; // Replace with your password
    const apiUrl1 = 'https://77.92.189.102/iiprecastverticaldemo/api/v1/BaqSvc/IIT_ElementStatusBAQ_Copy(PRECAST)'; // Adjust the URL as needed
    try {
      const response = await fetch(apiUrl1, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + btoa(username + ":" + password)
        }
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data1 = await response.json();
      // Check if data is an object and contains the 'value' property which is an array
      if (typeof data1 === 'object' && data1 !== null && Array.isArray(data1.value)) {
        // console.log('API Data:', data1.value);
        setApiData(data1.value);
        setIsLoading(false); // Load GIF
      } else {
        console.error('API response does not contain the expected array in the "value" property:', data1);
      }
    } catch (error) {
      console.error('There was a problem with your fetch operation:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []); // Add selectedProjectID as a dependency

  const renderTableRows = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentItems = apiData.slice(startIndex, endIndex);

    return currentItems.map((item, index) => (
      <tr key={index}>
        <td className='blue-hyper' onClick={() =>
          navigate(
            `/elementstatus/details/${item.Calculated_Area_Project}?UOM=${item.Area_AreaUOM_c}`
          )
        }>{item.Calculated_Area_Project}</td>
        <td>{item.Project_Description}</td>
        <td>{item.ProdGrup_Description}</td>
        <td>{item.Area_AreaUOM_c}</td>
        <td>
          <input
            type="checkbox"
            checked={item.Calculated_TotalRequiredQty ? 'true' : ''}
          />
        </td>
        <td>{item.Calculated_Entered}</td>
        <td>{item.Calculated_EnteredPercentage}</td>
        <td>
          <input
            type="checkbox"
            checked={item.Calculated_Approved ? 'true' : ''}
          />
        </td>
        <td>{item.Calculated_ApprovedPercentage}</td>
        <td>
          <input
            type="checkbox"
            checked={item.Calculated_Casted ? 'true' : ''}
          />
        </td>
        <td>{item.Calculated_CastedPercentage}</td>
        <td>{item.Calculated_Intransit}</td>
        <td>{item.Calculated_IntransitPercentage}</td>
        <td>{item.Calculated_OnSite}</td>
        <td>{item.Calculated_OnsitePercentage}</td>
        <td>{item.Calculated_Erected}</td>
        <td>{item.Calculated_ErectedPercentage}</td>
      </tr>
    ));
  };


  const goToNextPage = () => {
    const totalPages = Math.ceil(apiData.length / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Search Toggle
  const toggleSearch = () => {
    setSearchOpen(!searchOpen);
  }

  // Toggle table visibility
  const toggleTableVisibility = () => {
    setTableVisible(!tableVisible);
  }

  return (
    <div className='TruckMastertable'>
      {isLoading && (
        <div className="loading-overlay">
          <img src={GoCast} alt="Loading..." />
        </div>
      )}
      <div className='card rebartable'>
        {/* <h2 className='panel-title'> Element Status Dashboard </h2> */}
        <div className="card-header">
          <button type="button" className="toggle-table-icon" onClick={toggleTableVisibility}>
            <FontAwesomeIcon icon={tableVisible ? faArrowDown : faArrowUp} />
          </button>
          <h2 className='panel-title'>Summary</h2>
          <div className='ctrl-btns'>
          </div>
        </div>
        {/* Conditionally render the table */}
        {tableVisible && (
          <div className="card-body">
            <div class="table-responsive">
              <div className="scrollable-table-body">
                <table className="table table-bordered">
                  {/* Table content */}
                  <thead className='table-primary'>
                    <tr className='bg-primary text-white text-nowrap'>
                      <th>Project</th>
                      <th>Description</th>
                      <th>Product Group</th>
                      <th>UOM</th>
                      <th>Required</th>
                      <th>Entered</th>
                      <th>Entered Percentage</th>
                      <th>Approved</th>
                      <th>Approved Percentage</th>
                      <th>Casted</th>
                      <th>Casted Percentage</th>
                      <th>In-transit</th>
                      <th>Intransit Percentage</th>
                      <th>OnSite</th>
                      <th>Onsite Percentage</th>
                      <th>Erected</th>
                      <th>Erected Percentage</th>
                    </tr>
                  </thead>
                  <tbody>
                    {renderTableRows()}
                  </tbody>
                </table>
              </div>
              <div className="pagination">
                <button onClick={goToPreviousPage} disabled={currentPage === 1}>
                  <FontAwesomeIcon icon={faArrowLeft} />
                </button>
                <button onClick={goToNextPage} disabled={currentPage === Math.ceil(apiData.length / itemsPerPage)}>
                  <FontAwesomeIcon icon={faArrowRight} />
                </button>
              </div>
            </div>
          </div>

        )}
      </div>
    </div>
  );
}

export default ElementStatus_Dashboard;
